import React from 'react'
import Select from 'react-select';

function MultiSelect({
  name,
  value,
  onChange,
  onBlur,
  // touched,
  options,
  isInvalid,
  error,
  placeholder
}) {
  // const [isClearable, setIsClearable] = useState(true);
  const handleChange = selectedOptions => {
    onChange(name, selectedOptions);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <Select
      options={options}
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      isInvalid={isInvalid}
      // isClearable={isClearable}
      placeholder={placeholder ? placeholder : "Select one or more attributes"}
      error={error}
      isMulti
    />
  )
}

export default MultiSelect